"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var form_templates_html_1 = __importDefault(require("./form-templates.html"));
var form_templates_controller_1 = __importDefault(require("./form-templates.controller"));
var create_form_template_module_1 = __importDefault(require("./create-form-template/create-form-template.module"));
var edit_form_template_module_1 = __importDefault(require("./edit-form-template/edit-form-template.module"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.formtemplates", {
        url: "/form-templates",
        controller: "AdminFormTemplatesController",
        controllerAs: "vm",
        template: form_templates_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.formtemplates", [
    create_form_template_module_1.default.name,
    edit_form_template_module_1.default.name,
])
    .config(config)
    .controller("AdminFormTemplatesController", form_templates_controller_1.default);
